import { render, staticRenderFns } from "./SifrantZivalItem.vue?vue&type=template&id=3a72c17a&"
import script from "./SifrantZivalItem.vue?vue&type=script&lang=js&"
export * from "./SifrantZivalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports